module.exports = __webpack_public_path__ + "img/a7f1e93.jpg";